export const withStylePrefix = (styles) => {
    return (context, definition) => {
        if (definition.prefix) {
            return styles.replaceAll('chameleon-', `${definition.prefix}-`) + '\n' + styles;
        }
        return styles;
    };
};
